import http from './../base/api/public'
import querystring from 'querystring'
let apiUrl = require('@/../config/sysConfig')

export default {
  calcTimeDifference(time1, time2) {
    if (!time1 || !time2) {
      return 0
    }
    var timeArr1 = time1.split(":")
    var timeArr2 = time2.split(":")
    var minutes1 = Number(timeArr1[0]) * 60 + Number(timeArr1[1])
    var minutes2 = Number(timeArr2[0]) * 60 + Number(timeArr2[1])

    return minutes1 - minutes2;
  },
  /**
   * 入力した数値をコンマで毎3桁に分割する
   * 例：1234⇒1,234
   *     1234.5555⇒1,234.5555
   * @param {*} val フォマトの数値
   */
  decimalFormatter(val) {
    if (val != null) {
      let reg = new RegExp(/(?=(\d)+(\.\d+)?$)/, 'g')
      if (reg.test(val)) {
        let valArr = val.split('.')
        valArr[0] = valArr[0].replace(/^0+\./, '0.').replace(/^0+([0-9])/, '$1').replace(/(?=(\B)(\d{3})+$)/g, '$1,')
        return valArr.length == 1 ? valArr[0] : valArr[0] + '.' + valArr[1]
      }
    }

    return val
  },

  // 带,金额转number
  strToNum(val) {
    if (val != null && val !== '') {
      return Number(val.replace(/,/g, ''))
    } else {
      return 0
    }
  },

  /**
   * 四舍五入
   * @param {*} num 変数
   * @param {*} n 小数桁数
   */
  tofixeds(num, n) {
    var flag = 1
    if (num < 0) {
      flag = -1
      num *= -1
    }

    num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) + Math.pow(10, -(n + 1));
    return (num * flag).toFixed(n);
  },


  // 日期格式化（yyyy/MM/dd）
  timeDefault(date) {
    // 如果没有传日期参数，默认为系统时间
    if (!date) {
      var date = new Date();
    } else {
      var date = new Date(date);
    }
    var curr_date = date.getDate();
    var curr_month = date.getMonth() + 1;
    var curr_year = date.getFullYear();
    String(curr_month).length < 2 ? (curr_month = "0" + curr_month) : curr_month;
    String(curr_date).length < 2 ? (curr_date = "0" + curr_date) : curr_date;
    var s1 = curr_year + "/" + curr_month + "/" + curr_date;
    return s1;
  },
  //时间格式化
  timeFormatter(val) {
    var reg = /[^\d]/
    if (reg.test(val)) (
      val = val.replace(/[^0-9]/ig, "")
    )
    if (val.length == 1) {
      val = '0' + val + ':00'
    } else if (val.length == 2) {
      val = '00:' + val
    } else if (val.length == 3) {
      val = '0' + val[0] + ':' + val[1] + val[2]
    } else {
      val = val[0] + val[1] + ':' + val[2] + val[3]
    }
    var regex = /^([0-9][0-9]|4[0-5]):([0-5][0-9])$/;
    if (!regex.test(val)) {
      val = '00:00'
    }
    return val
  },
  //时间去掉毫秒的部分
  extractMillisecond(obj) {
    if (obj == null || obj == "") {
      return ""
    }
    var index = obj.lastIndexOf("\.");
    if (index == "-1") {
      return obj;
    } else {
      return obj.substring(0, index);
    }
  },

  // 时间戳（yyyyMMddHHmmssSSS）
  timeNumberGet() {
    this.time_Format = new Date();
    let date = new Date();
    let yyyy = date.getFullYear().toString();
    let mm = (date.getMonth() + 1).toString().padStart(2, '0');
    let dd = date.getDate().toString().padStart(2, '0');
    let hh = date.getHours().toString().padStart(2, '0');
    let min = date.getMinutes().toString().padStart(2, '0');
    let ss = date.getSeconds().toString().padStart(2, '0');
    let ms = date.getMilliseconds().toString();
    String(ms).length < 2 ? (ms = "0" + ms) : ms;
    String(ms).length < 3 ? (ms = "0" + ms) : ms;
    var s1 = yyyy + mm + dd + hh + min + ss + ms;
    return s1;
  },
  /**
   * 获取上一个月
   *
   * @date 格式为yyyy/mm/dd的日期，如：2014/01/25
  */
  getPreMonth(date) {
      var arr = date.split('/');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '/' + month2 + '/' + day2;
      return t2;
  },
  /**
   * 获取下一个月
   *
   * @date 格式为yyyy/mm/dd的日期，如：2014/01/25
   */  
  getNextMonth(date) {
      var arr = date.split('/');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
  
      var t2 = year2 + '/' + month2 + '/' + day2;
      return t2;
  },
  /**
   * 获取月末日
   *  @date 格式为yyyy/mm/dd的日期，如：2014/01/25
   */
  getLastDayOfMonth(date) {
    if (!date) {
      var date = new Date();
    } else {
      var date = new Date(date);
    }
    
    //下一个月1日
    const firstDayOfNextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);

    //减1日，这个月月末日
    const LastDayOfThisMonth = firstDayOfNextMonth.setDate(firstDayOfNextMonth.getDate() - 1);

    var s1 = this.timeDefault(LastDayOfThisMonth);

    return s1;
  },
  isEmpty(obj) {
    if (obj == null || obj == "" || obj == undefined) {
      return true
    }
    return false
  },
  /**
* 输入金额校验
* @param {*} value  输入值
* @param {*} maxIntNum 最大整数位
* @param {*} maxDecNum 最大小数位
* @param {*} canNegativeNum 是否能输入负数 不传默认false（不能输入负号）
*/
  validitMoney(value, maxIntNum, maxDecNum, canNegativeNum) {
    if (canNegativeNum == '' || canNegativeNum == null || canNegativeNum == undefined) {
      canNegativeNum = false;
    }
    if (canNegativeNum == true) {
      value = value.replace(/[^\-\d.]/g, '') // 只能输入.和-和数字
    } else {
      value = value.replace(/[^\d.]/g, '')  //第一个字符不能是-
    }
    value = value.replace(/^\./g, '')  //第一个字符不能是.
    value = value.replace(/\.{2,}/g, '.') // 不能连续输入. 
    value = value.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
    value = value.replace(/(-)\./g, '$1') // -后面不能输入.
    value = value.replace(/\-{2,}/g, '-') // -只能保留一个
    value = value.replace(/(\d+|\.)-/g, '$1') // 数字和.后面不能接-,不能出现类似11-, 12.-
    value = value.replace(/-(0){2,}/g, "$1") // 不能出现-00,-001,-0001类似
    value = value.replace(/(-)0+(\d+)/g, '$1$2') // 不能出现-01,-02类似
    value = value.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
    let regMaxIntNum = new RegExp('(\\d{' + maxIntNum + '})\\d*');
    value = value.replace(regMaxIntNum, '$1') // 最多保留6位整数
    let regMaxDecNum1 = new RegExp('(\\.\\d{' + maxDecNum + '})\\d*')
    value = value.replace(regMaxDecNum1, '$1')// 最多保留2位小数
    // value = value.replace(/(\d{6})\d*/, '$1') // 最多保留6位整数
    // value = value.replace(/(\.\d{2})\d*/, '$1')// 最多保留2位小数
    return value;
  },
  /* 
  日付より曜日を返す
  date: 日期参数(date:yyyy/mm/dd)
*/
  getWeek(date) {
    var dateArray = date.split('/');
    var week = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
    return week.getDay() + 1;
  },
  //「作業開始／作業完了／戻す」処理
  async jobStateEdit(inputParam) {
    var retInfo = {}
    var strSysdate = this.timeDefault()
    //作業開始
    if (inputParam.btnType === '1') {
      // 作業日チェック
      if (strSysdate !== inputParam.jobDate) {
        retInfo.code = '310'
        retInfo.msgID = 'MSG_ERROR_INSTORE_JOBDATE'
        return retInfo
      }
      var param = {}
      param.crewCd = inputParam.crewCd
      //param.orderNo = inputParam.orderNo
      param.jobState = '1'
      param.gamenId = inputParam.gamenId
      param.jobStateFlg = '0'
      param.checkFlg = inputParam.checkFlg
      param.jobDate = inputParam.jobDate
      param.salesOfficeCd = inputParam.salesOfficeCd//営業所CD
      param.gamenIdRoleChk = inputParam.gamenIdRoleChk //画面ID(権限チェック用)
      retInfo = await http.requestPost(apiUrl.apiUrl_WorkJobstate, param).then(res => {
        retInfo.code = res.code
        retInfo.msgID = res.message
        return retInfo
      })
    } else if (inputParam.btnType === '2') {//作業完了
      if (inputParam.checkFlg === '1') {
        var checkParam = {}
        checkParam.div = '1'
        checkParam.crewCd = inputParam.crewCd
        let querys = querystring.stringify(checkParam)
        retInfo = await http.requestGet(apiUrl.apiUrl_Check + '?' + querys).then(res => {
          retInfo.code = res.code
          retInfo.msgID = res.message
          return retInfo
        })
      } else {
        var param = {}
        param.crewCd = inputParam.crewCd
        //  param.orderNo = inputParam.orderNo
        param.jobState = '2'
        param.gamenId = inputParam.gamenId
        param.jobStateFlg = '1'
        param.checkFlg = inputParam.checkFlg
        param.jobDate = inputParam.jobDate
        param.salesOfficeCd = inputParam.salesOfficeCd//営業所CD
        param.gamenIdRoleChk = inputParam.gamenIdRoleChk //画面ID(権限チェック用)
        retInfo = await http.requestPost(apiUrl.apiUrl_WorkJobstate, param).then(res => {
          retInfo.code = res.code
          retInfo.msgID = res.message
          return retInfo
        })
      }
    } else if (inputParam.btnType === '3') { //戻す
      var param = {}
      param.crewCd = inputParam.crewCd
      //  param.orderNo = inputParam.orderNo
      param.jobState = '1'
      param.gamenId = inputParam.gamenId
      param.jobStateFlg = '2'
      param.checkFlg = inputParam.checkFlg
      param.jobDate = inputParam.jobDate
      param.salesOfficeCd = inputParam.salesOfficeCd//営業所CD
      param.gamenIdRoleChk = inputParam.gamenIdRoleChk //画面ID(権限チェック用)
      retInfo = await http.requestPost(apiUrl.apiUrl_WorkJobstate, param).then(res => {
        retInfo.code = res.code
        retInfo.msgID = res.message
        return retInfo
      })
    }
    return retInfo
  },
}



// WEBPACK FOOTER //
// ./src/common/utils.js